import React from 'react';

const Marketing = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        Our marketing communications:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Require explicit opt-in consent</li>
        <li>Include easy unsubscribe options</li>
        <li>Respect communication preferences</li>
        <li>Never share contact information with third parties</li>
      </ul>
    </div>
  );
};

export default Marketing;